import permissions from 'constants/permissions'

const OBSERVER_ORGANIZATION_LIST = [
  {
    name: 'Gerenciar observadores de um incidente',
    tag: permissions.OBSERVERS_ORGANIZATIONS.MANAGE_OBSERVERS_INCIDENT,
  },
  {
    name: 'Gerenciar observadores de um ticket',
    tag: permissions.OBSERVERS_ORGANIZATIONS.MANAGE_OBSERVERS_TICKET,
  },
]

export default OBSERVER_ORGANIZATION_LIST
